import * as React from 'react';
import { EnergyLabel } from './EnergyLabel';

export interface IEnergyLabelComparisonProps {
  primaryVehicleId: string;
  comparingVehicleId: string;
  primaryImageUrl: string | null;
  comparingImageUrl: string | null;
}

export const EnergyLabelComparison: React.FC<IEnergyLabelComparisonProps> = ({
  primaryVehicleId,
  comparingVehicleId,
  primaryImageUrl,
  comparingImageUrl,
}) => {
  if (!primaryImageUrl && !comparingImageUrl) return null;

  return (
    <div className="flex items-center gap-1" data-testid="energy-label-comparison">
      {primaryImageUrl && <EnergyLabel vehicleId={primaryVehicleId} imageUrl={primaryImageUrl} />}
      {comparingImageUrl && <EnergyLabel vehicleId={comparingVehicleId} imageUrl={comparingImageUrl} />}
    </div>
  );
};
